import { Home, RefreshCw, Store, Wallet } from "lucide-react";
import Reveal from "@/components/site/Reveal";

const services = [
  { icon: Home, title: "Pinjaman Rumah Pertama", desc: "Bimbingan khas untuk pembeli rumah kali pertama, termasuk skim kerajaan." },
  { icon: RefreshCw, title: "Refinance / Pembiayaan Semula", desc: "Kurangkan ansuran bulanan atau keluarkan tunai daripada nilai rumah anda." },
  { icon: Store, title: "Hartanah Komersial", desc: "Pembiayaan untuk kedai, pejabat dan hartanah pelaburan." },
  { icon: Wallet, title: "Semakan CCRIS/CTOS", desc: "Nasihat memperbaiki kedudukan kredit sebelum memohon pinjaman." },
];

export default function Services() {
  return (
    <section id="khidmat" data-testid="services-section" className="py-24 md:py-32 bg-white">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal>
          <div className="max-w-2xl">
            <span className="text-sm font-semibold uppercase tracking-wider text-[#1D4ED8]">
              Khidmat Saya
            </span>
            <h2 className="mt-3 text-3xl md:text-4xl font-extrabold tracking-tight text-[#0A2540]">
              Penyelesaian pinjaman untuk setiap keperluan
            </h2>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
          {services.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.08}>
              <div
                data-testid={`service-card-${i + 1}`}
                className="flex items-start gap-5 rounded-2xl border border-slate-200 p-7 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-[#1D4ED8]"
              >
                <div className="shrink-0 rounded-xl bg-[#F8F9FA] border border-slate-200 p-3">
                  <s.icon className="h-6 w-6 text-[#1D4ED8]" />
                </div>
                <div>
                  <h3 className="font-heading text-lg font-bold text-[#0A2540]">{s.title}</h3>
                  <p className="mt-1.5 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
